import { IOrderNotificationPreference } from '../../models/order-notification-preference';
import { IResult, IErrorResult } from '../../models/result-models';
import {
    LOAD_ORDER_PREFERENCES_SUCCESS,
    ORDER_PREFERENCES_FATAL,
} from './order-preferences-actions';
import { initialSate } from '../initial-state-array';

interface ILoadOrderPreferencesSuccess {
    type: 'LOAD_ORDER_PREFERENCES_SUCCESS';
    payload: IResult<IOrderNotificationPreference[]>;
}

interface IOrderPreferencesFatal {
    type: 'ORDER_PREFERENCES_FATAL';
    payload: IErrorResult;
}

type KnownAction = ILoadOrderPreferencesSuccess | IOrderPreferencesFatal;

export const orderPreferencesReducer = (
    state: IResult<IOrderNotificationPreference[]> = initialSate,
    action: KnownAction
) => {
    switch (action.type) {
        case LOAD_ORDER_PREFERENCES_SUCCESS:
            return action.payload;
        case ORDER_PREFERENCES_FATAL:
            return {
                ok: false,
                data: state.data,
                message: action.payload.errorMessage,
            };
        default:
            return state;
    }
};
